export default {"src":"/_next/static/media/for-corporates.df5a70e2.svg","height":13,"width":18,"blurWidth":0,"blurHeight":0};